'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconEye, iconEyeTag } from '@ni/nimble-components/dist/esm/icons/eye';
import { wrap } from '../../utilities/react-wrapper';

export type { IconEye };
export { iconEyeTag };
export const NimbleIconEye = wrap(IconEye);